<script>
	import { uiText } from "../lib/uiText.js";
	import { createEventDispatcher } from "svelte";
	const dispatch = createEventDispatcher();
	export let lang = "en";
	let ui = uiText(lang);
	$: lang, (ui = uiText(lang));
	export let pastAnswers = [];
	export let riddle;
	// console.log(riddle);
	let progbar = riddle.progbar;
	let type = riddle.type || "single";
	let answers = riddle.answers;
	let input = "";
	let wrongAnswers = [];

	let requiredAnswers = riddle.requiredAnswers || false;

	const inActive = [];
	const inPast = [];

	// console.log(pastAnswers);
	// console.log(Object.keys(pastAnswers));
	// console.log(Object.keys(answers));
	let pastAnswerKeys = Object.keys(pastAnswers);
	let answerKeys = Object.values(answers);
	// console.log(answerKeys);
	for (let i = 0; i < answers.length; i++) {
		let singAnw;
		if (typeof answerKeys[i] === "object") {
			singAnw = Object.values(answerKeys[i])[0];
			// console.log(Object.values(answerKeys[i])[0]);
		} else {
			singAnw = answerKeys[i];
			// console.log(answerKeys[i]);
		}
		inPast[i] = pastAnswerKeys.some((el) => singAnw.toLowerCase().includes(el));
	}
	// console.log(inPast);

	// export let prog
	//$: input,
	//console.log('Single: ' + input.toLowerCase().includes(answers[0])), //сингъл
	//console.log('Multiple: ' + answers.some((el) => input.toLowerCase().includes(el))); //мултипъл

	// console.log(pastAnswers);
	//

	// MADE OBSOLETE BY GEMINI
	// 	function checkAnswer() {
	// 		if (input == "" || input.replace(/\s/g, "") == "") {
	// 			console.warn("don't try empty answers, man!");
	// 			return;
	// 		}
	// 		switch (
	// 			type // single <> multiple <> mc (multiple correct) <> mc-multiple || single <> multiple for a start
	// 		) {
	// 			// SASP SAMP MASP MAMP single Answer multiple Possibilities
	// 			case "single":
	// 				if (input.toLowerCase().includes(answers[0])) {
	// 					dispatch("message", {
	// 						msg_content: ui.game.riddle.single_message,
	// 						msg_type: "info",
	// 						msg_action: ui.game.riddle.single_action,
	// 					});
	// 					dispatch("solve", {
	// 						address: riddle.address,
	// 						wrongAnswers: wrongAnswers,
	// 					});
	// 				} else {
	// 					dispatch("message", {
	// 						msg_content: ui.game.riddle.wrong_message,
	// 						msg_type: "error",
	// 						msg_action: ui.game.riddle.wrong_action,
	// 					});
	// 					wrongAnswers.push(input);
	// 					dispatch("wrongAnswer", {
	// 						//wrongAnswer
	// 						// address: riddle.address,
	// 						wrongAnswer: wrongAnswers[wrongAnswers.length - 1],
	// 						// isBonus: isBonus,
	// 					});
	// 				}
	// 				break;

	// 			case "mc": //multiple correct
	// 				if (answers.some((el) => input.toLowerCase().includes(el))) {
	// 					dispatch("checkPartialSolve", { [input]: true }); //NEW JULY25

	// 					if (
	// 						Object.keys(pastAnswers).some((el) =>
	// 							input.toLowerCase().includes(el),
	// 						)
	// 					) {
	// 						dispatch("message", {
	// 							msg_content: ui.game.riddle.multiple_repeat_message,
	// 							msg_type: "error",
	// 							msg_action: ui.game.riddle.multiple_repeat_action,
	// 						});
	// 					} else {
	// 						dispatch("partialSolve", { [input]: true });
	// 					}
	// 				} else {
	// 					dispatch("message", {
	// 						msg_content: ui.game.riddle.wrong_message,
	// 						msg_type: "error",
	// 						msg_action: ui.game.riddle.wrong_action,
	// 					});
	// 					wrongAnswers.push(input);
	// 					dispatch("wrongAnswer", {
	// 						//wrongAnswer
	// 						// address: riddle.address,
	// 						wrongAnswer: wrongAnswers[wrongAnswers.length - 1],
	// 						// isBonus: isBonus,
	// 					});
	// 				}

	// 				break;

	// 			case "mc-multiple":
	// 				let mc_multiple = answers;

	// 				for (let i = 0; i < mc_multiple.length; i++) {
	// 					if (typeof mc_multiple[i] === "object") {
	// 						inActive[i] = Object.values(mc_multiple[i]).some((el) =>
	// 							input.toLowerCase().includes(el),
	// 						);
	// 					} else {
	// 						inActive[i] = input.toLowerCase().includes(mc_multiple[i]);
	// 					}
	// 				}
	// 				checkMCMultiple(inActive);

	// 				break;

	// 			default:
	// 				alert(
	// 					"How?! You should not be seeing this... Well, looks like one of the elves messed up... Please report to Santa..um..I mean Obelisk at obelisk [at] vutreshenglas.com. Thanks!",
	// 				);
	// 		}
	// 	}
	// // MADE OBSOLETE BY GEMINI
	// 	function checkMCMultiple(data) {
	// 		let index = data.indexOf(true);

	// 		if (index >= 0) {
	// 			if (!inPast[index]) {
	// 				dispatch("partialSolveType2", { inActive });
	// 			} else {
	// 				dispatch("checkPartialSolve", { [input]: true }); //NEW JULY25

	// 				dispatch("message", {
	// 					msg_content: ui.game.riddle.multiple_repeat_message,
	// 					msg_type: "error",
	// 					msg_action: ui.game.riddle.multiple_repeat_action,
	// 				});
	// 			}
	// 		} else {
	// 			dispatch("message", {
	// 				msg_content: ui.game.riddle.wrong_message,
	// 				msg_type: "error",
	// 				msg_action: ui.game.riddle.wrong_action,
	// 			});
	// 			wrongAnswers.push(input);
	// 			dispatch("wrongAnswer", {
	// 				//wrongAnswer
	// 				// address: riddle.address,
	// 				wrongAnswer: wrongAnswers[wrongAnswers.length - 1],
	// 				// isBonus: isBonus,
	// 			});
	// 		}
	// 	}

	function checkAnswer() {
		if (input == "" || input.replace(/\s/g, "") == "") {
			console.warn("don't try empty answers, man!");
			return;
		}

		let lowerInput = input.toLowerCase();

		switch (type) {
			case "single":
				if (lowerInput.includes(answers[0])) {
					dispatch("message", {
						msg_content: ui.game.riddle.single_message,
						msg_type: "info",
						msg_action: ui.game.riddle.single_action,
					});
					dispatch("solve", {
						address: riddle.address,
						wrongAnswers: wrongAnswers,
					});
				} else {
					dispatch("message", {
						msg_content: ui.game.riddle.wrong_message,
						msg_type: "error",
						msg_action: ui.game.riddle.wrong_action,
					});
					wrongAnswers.push(input);
					dispatch("wrongAnswer", {
						wrongAnswer: wrongAnswers[wrongAnswers.length - 1],
					});
				}
				break;

			case "mc": // multiple correct
				let newMcMatches = [];
				let repeatMcMatches = false;

				// Scan the single input string for ALL valid answers
				answers.forEach((ans) => {
					if (lowerInput.includes(ans)) {
						let alreadySolved = Object.keys(pastAnswers).some(
							(el) =>
								ans.toLowerCase().includes(el) ||
								el.toLowerCase().includes(ans.toLowerCase()),
						);

						if (alreadySolved) {
							repeatMcMatches = true;
						} else {
							newMcMatches.push(ans);
						}
					}
				});

				if (newMcMatches.length > 0) {
					// Group all matches into a single payload object
					let matchPayload = {};
					newMcMatches.forEach((match) => {
						matchPayload[match] = true;
					});

					// Dispatch once with the full payload
					dispatch("partialSolve", matchPayload);
					input = ""; // Clear the input field for the next batch
				} else if (repeatMcMatches) {
					dispatch("message", {
						msg_content: ui.game.riddle.multiple_repeat_message,
						msg_type: "error",
						msg_action: ui.game.riddle.multiple_repeat_action,
					});
				} else {
					dispatch("message", {
						msg_content: ui.game.riddle.wrong_message,
						msg_type: "error",
						msg_action: ui.game.riddle.wrong_action,
					});
					wrongAnswers.push(input);
					dispatch("wrongAnswer", {
						wrongAnswer: wrongAnswers[wrongAnswers.length - 1],
					});
				}
				break;

			case "mc-multiple":
				let mc_multiple = answers;
				let currentInActive = [];
				let foundNewMcm = false;
				let foundRepeatMcm = false;

				for (let i = 0; i < mc_multiple.length; i++) {
					let isMatch = false;

					// Check if the input contains a match for THIS specific slot
					if (typeof mc_multiple[i] === "object") {
						isMatch = Object.values(mc_multiple[i]).some((el) =>
							lowerInput.includes(el),
						);
					} else {
						isMatch = lowerInput.includes(mc_multiple[i]);
					}

					currentInActive[i] = isMatch;

					if (isMatch) {
						if (inPast[i]) {
							foundRepeatMcm = true;
						} else {
							foundNewMcm = true;
						}
					}
				}

				if (foundNewMcm) {
					// Dispatches the entire array of matches (e.g., [true, true, false]) at once
					dispatch("partialSolveType2", { inActive: currentInActive });
					input = ""; // Clear the input field
				} else if (foundRepeatMcm) {
					dispatch("checkPartialSolve", { [input]: true });
					dispatch("message", {
						msg_content: ui.game.riddle.multiple_repeat_message,
						msg_type: "error",
						msg_action: ui.game.riddle.multiple_repeat_action,
					});
				} else {
					dispatch("message", {
						msg_content: ui.game.riddle.wrong_message,
						msg_type: "error",
						msg_action: ui.game.riddle.wrong_action,
					});
					wrongAnswers.push(input);
					dispatch("wrongAnswer", {
						wrongAnswer: wrongAnswers[wrongAnswers.length - 1],
					});
				}
				break;

			default:
				alert(
					"How?! You should not be seeing this... Well, looks like one of the elves messed up... Please report to Santa..um..I mean Obelisk at obelisk [at] vutreshenglas.com. Thanks!",
				);
		}
	}

	const handleEnter = (e) => {
		if (e.key === "Enter" || e.keyCode === 13) {
			checkAnswer();
		}
	};

	// console.log(inPast, inActive);
</script>

<div class="input-row">
	<input
		class="grow"
		type="text"
		name="field"
		id="field"
		placeholder="_"
		bind:value={input}
		on:keyup={handleEnter}
	/>
	<button id="trigger" on:click={checkAnswer}>{ui.game.aside.button}</button>
</div>
<ul id="progress">
	{#if type == "mc"}
		{#if requiredAnswers}
			<li class="text-center mx-auto">
				{inPast.filter(Boolean).length} / {riddle.requiredAnswers}
			</li>
		{:else}
			{#each riddle.answers as answer, i}
				{#if Object.keys(pastAnswers).some((el) => answer
						.toLowerCase()
						.includes(el))}
					<li class="correct" title={ui.game.aside.answer_revealed}>
						<i class="fa-solid fa-check" />
					</li>
				{:else}
					<li style="order:2" title={ui.game.aside.answer_hidden}>
						<i class="fa-solid fa-question" />
					</li>
				{/if}
			{/each}
		{/if}
	{/if}
	{#if type == "mc-multiple"}
		{#if requiredAnswers}
			<li class="text-center mx-auto">
				{inPast.filter(Boolean).length} / {riddle.requiredAnswers}
			</li>
		{:else}
			{#each riddle.answers as answer, i}
				{#if typeof answer === "object"}
					{#if inPast[i]}
						<li class="correct" title={ui.game.aside.answer_revealed}>
							<i class="fa-solid fa-check" />
						</li>
					{:else}
						<li style="order:2" title={ui.game.aside.answer_hidden}>
							<i class="fa-solid fa-question" />
						</li>
					{/if}
				{:else if Object.keys(pastAnswers).some((el) => answer
						.toLowerCase()
						.includes(el))}
					<li class="correct" title={ui.game.aside.answer_revealed}>
						<i class="fa-solid fa-check" />
					</li>
				{:else}
					<li style="order:2" title={ui.game.aside.answer_hidden}>
						<i class="fa-solid fa-question" />
					</li>
				{/if}
			{/each}
		{/if}
	{/if}
</ul>

<style>
	#progress {
		display: flex;
		flex-wrap: wrap;
		width: 100%;
		padding: 10px;
		gap: 10px;
	}
	#progress li {
		border: 2px solid white;
		flex: 1;
		box-shadow: #093a86 5px 5px 0;
		text-align: center;
	}

	#progress li.correct {
		color: white;
		border: 2px solid #51df67;
		background-color: rgb(22 163 74);
	}
	#progress li i {
		line-height: inherit;
	}

	.input-row {
		display: grid;
		grid-template-columns: 1fr max-content;
	}
	@media screen and (max-width: 480px) {
		.input-row {
			grid-template-columns: auto;
		}
	}
</style>
